import basePath from "base_path";

import ActionTypes from "../constants/action_types";
import createReduxPromiseAction from "utils/create_redux_promise_action";

import rateLimit, {getStandardTimeout} from "utils/rate_limit";
import {createChangeTimeWrapper} from "utils/ensure_fresh_update";

function doSave(
  requestor,
  organisationId,
  issueId,
  lastEdited,
  data,
  changeTime,
) {
  return requestor
    .patch(
      `${basePath}/organisation/${organisationId}/issue/${issueId}`,
      {...data, last_edited: lastEdited},
      {withCredentials: true},
    )
    .then(response => ({
      ...createChangeTimeWrapper(changeTime),
      ...response.data,
    }));
}

const save = rateLimit(doSave, getStandardTimeout());

export default function updateIssue(requestor) {
  const action = createReduxPromiseAction(
    ActionTypes.ISSUE_UPDATE,
    (organisationId, issueId, lastEdited, data, changeTime) => {
      return save(
        requestor,
        organisationId,
        issueId,
        lastEdited,
        data,
        changeTime,
      );
    },
    (organisationId, issueId, lastEdited, data, changeTime) => ({
      ...createChangeTimeWrapper(changeTime),
      id: issueId,
      last_edited: lastEdited,
      ...data,
    }),
  );

  return action;
}
